// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__uJ2I6"};